
import { defineComponent } from "vue";

export default defineComponent({
  name: "LButtom",
  props: {
    text: { type: String, default: "" },
    disabledB: { type: Boolean, default: false },
  },
});
